module.exports = __webpack_public_path__ + "img/blt-pagetop.408fa5ac.svg";